// libs
import React, { memo } from "react";
import escapeRegExp from "lodash/escapeRegExp";
import styled from "@emotion/styled";

// helpers
import { setNewSearch, generateTrackingURLForSearch } from "shared/components/HeaderSearch/helpers";

// constants
import { SEARCH_TERM_TYPE, SEARCH_TYPE } from "shared/components/HeaderSearch/constants";

// styles
const SuggestionContainer = styled.div`
    display: block;
    padding: 0 10px;
    height: 40px;
    margin: 0 -20px;
    width: calc(100% + 40px);

    &:hover {
        background: #f8f8f8;
    }

    & > .sg-anc {
        display: block;
        height: 100%;
        text-decoration: none;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 40px;

        & > .sg-hl {
            font-weight: 600;
        }
    }
`;

// defs
interface ISuggestionProps {
    clickIndex: number;
    url: string;
    title: string;
    term: string;
    type: string;
}

function Suggestion({ clickIndex, url, title, term, type }: ISuggestionProps) {
    const goToUrl: React.MouseEventHandler = e => {
        e.preventDefault();
        setNewSearch({ url, term: title, type: SEARCH_TERM_TYPE.PRODUCT });

        window.location.href = generateTrackingURLForSearch({
            url,
            searchType: SEARCH_TYPE.AUTO_COMPLETE,
            internalSearchTerm: title,
            typedSearchTerm: term,
            suggestionType: type,
            clickIndex,
        });
    };

    const regxp = new RegExp(`(${escapeRegExp(term)})`, "ig");
    const decoratedTitle = title.replace(regxp, "<span class='sg-hl'>$1</span>");

    return (
        <SuggestionContainer>
            <a
                href={url}
                onClick={goToUrl}
                className="sg-anc"
                dangerouslySetInnerHTML={{
                    __html: decoratedTitle,
                }}
                data-test="suggestion-anchor"
            />
        </SuggestionContainer>
    );
}

export default memo(Suggestion);
